import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tree_view = _resolveComponent("tree-view")!

  return (_ctx.treeNodes?.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_tree_view, {
          "data-items": _ctx.treeNodes,
          "data-item-key": "id",
          "text-field": "text",
          "check-field": "checked",
          "check-indeterminate-field": "checkedIndeterminate",
          "expand-field": "expanded",
          checkboxes: true,
          "expand-icons": true,
          item: "itemCell",
          onCheckchange: _ctx.onCheckChange,
          onItemclick: _ctx.onCheckChange,
          onExpandchange: _ctx.onExpandChange
        }, {
          itemCell: _withCtx(({props}) => [
            _createElementVNode("span", null, [
              _createElementVNode("span", {
                class: _normalizeClass(props.className),
                style: _normalizeStyle({ color: props.item.resultCount === 0 ? 'lightgray' : 'black' } )
              }, _toDisplayString(props.item.text) + " " + _toDisplayString(_ctx.getResultCountString(props.item)), 7)
            ])
          ]),
          _: 1
        }, 8, ["data-items", "onCheckchange", "onItemclick", "onExpandchange"])
      ]))
    : _createCommentVNode("", true)
}